import { ThemedBenificiaryRemitterPage as BenificiaryRemitterPage } from './benificiary';
export const ThemedBenificiaryRemitterPage = BenificiaryRemitterPage;
